import {
  evaluationDataId,
  evaluationDataEng,
  totalSample,
  avgF1Score,
} from '../../utils/data-agate';

const EvaluationMobile = ({ isEnglish }) => (
  <div className='md:hidden'>
    <table className='min-w-full table-auto overflow-hidden shadow-xl rounded-lg mb-2'>
      <thead className='bg-axel-3'>
        <tr>
          {['Classification', '', '', 'F1 - Score'].map((text, i) => (
            <th key={i} className='font-medium p-2 text-left w-max'>
              {text}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {(isEnglish ? evaluationDataEng : evaluationDataId).map(
          (row, index) => (
            <tr key={index}>
              <td className='p-2 align-top bg-axel-1'>{row.classification}</td>
              <td className='p-2 align-top bg-mainBlue-1' colSpan={2}>
                <p>TBS Sample: {row.sample}</p>
                <p>Precision: {row.precision}</p>
                <p>Recall: {row.precision}</p>
              </td>
              <td className='p-2 align-top font-bold text-center'>{row.f1}</td>
            </tr>
          )
        )}
      </tbody>
      <tfoot>
        <tr className='font-medium'>
          <td className='bg-axel-3 p-2 text-center' colSpan={2}>
            Total Sample <br />
            {totalSample}
          </td>
          <td className='bg-axel-5 p-2 font-bold text-center' colSpan={2}>
            {isEnglish ? 'Total Accuracy' : 'Total Akurasi'} <br />
            {avgF1Score}
          </td>
        </tr>
      </tfoot>
    </table>
    <p className='text-center text-neutral-7 mt-2'>
      {isEnglish
        ? 'F1-Score performance evaluation table'
        : 'Tabel evaluasi rata rata f1-score'}
    </p>
  </div>
);

export default EvaluationMobile;
